import { type Temporal } from '@js-temporal/polyfill'

import serializeInstant from './serializeInstant'

export default function serializeZonedDateTime (zonedDateTime: Temporal.ZonedDateTime): string {
  return serializeInstant(zonedDateTime.toInstant())
}
